export default __webpack_public_path__ + "static/media/pdi_id.0328cff0.csv";